module.exports = __webpack_public_path__ + "img/lingshiMap.53c242ef.png";